import { createSelector } from 'reselect';

export const getComponentState = state => state.editor;

export const getTemplateCode = createSelector(
    getComponentState,
    (state) => state.templateCode
);
export const getName = createSelector(
    getComponentState,
    (state) => state.variables.name
);
export const getCredentials = createSelector(
    getComponentState,
    (state) => state.variables.credentials
);
export const getTitle1 = createSelector(
    getComponentState,
    (state) => state.variables.title1
);
export const getTitle2 = createSelector(
    getComponentState,
    (state) => state.variables.title2
);
export const getTitle3 = createSelector(
    getComponentState,
    (state) => state.variables.title3
);
export const getDepartment1 = createSelector(
    getComponentState,
    (state) => state.variables.department1
);
export const getDepartment2 = createSelector(
    getComponentState,
    (state) => state.variables.department2
);
export const getDepartment3 = createSelector(
    getComponentState,
    (state) => state.variables.department3
);
export const getPhone = createSelector(
    getComponentState,
    (state) => state.variables.phone
);
export const getClinic = createSelector(
    getComponentState,
    (state) => state.variables.clinic
);
export const getFax = createSelector(
    getComponentState,
    (state) => state.variables.fax
);
export const getPager = createSelector(
    getComponentState,
    (state) => state.variables.pager
);
export const getAddress = createSelector(
    getComponentState,
    (state) => state.variables.address
);
export const getAddress2 = createSelector(
    getComponentState,
    (state) => state.variables.address2
);
export const getAddress3 = createSelector(
    getComponentState,
    (state) => state.variables.address3
);
export const getCity = createSelector(
    getComponentState,
    (state) => state.variables.city
);
export const getState = createSelector(
    getComponentState,
    (state) => state.variables.state
);
export const getZip = createSelector(
    getComponentState,
    (state) => state.variables.zip
);
export const getEmail = createSelector(
    getComponentState,
    (state) => state.variables.email
);
export const getShowEmail = createSelector(
    getComponentState,
    (state) => state.variables.showEmail
);
export const getOpen1 = createSelector(
    getComponentState,
    (state) => state.variables.open1
);
export const getOpen2 = createSelector(
    getComponentState,
    (state) => state.variables.open2
);
export const getOpen3 = createSelector(
    getComponentState,
    (state) => state.variables.open3
);
export const getQuantity = createSelector(
    getComponentState,
    (state) => state.variables.quantity
);
export const getFrontDataUrl = createSelector(
    getComponentState,
    (state) => state.variables.frontDataUrl
);
export const getBackDataUrl = createSelector(
    getComponentState,
    (state) => state.variables.backDataUrl
);
export const getCell = createSelector(
    getComponentState,
    (state) => state.variables.cell
);
export const getShowCell = createSelector(
    getComponentState,
    (state) => state.variables.showCell
);
export const getLocationNames = createSelector(
    getComponentState,
    (state) => state.variables.locationNames
);
export const getLocationPhones = createSelector(
    getComponentState,
    (state) => state.variables.locationPhones
);
export const getLocationFaxes = createSelector(
    getComponentState,
    (state) => state.variables.locationFaxes
);
export const getLocationNursePhones = createSelector(
    getComponentState,
    (state) => state.variables.locationNursePhones
);
export const getLocationAddresses1 = createSelector(
    getComponentState,
    (state) => state.variables.locationAddresses1
);
export const getLocationAddresses2 = createSelector(
    getComponentState,
    (state) => state.variables.locationAddresses2
);
export const getLocationAddresses3 = createSelector(
    getComponentState,
    (state) => state.variables.locationAddresses3
);
export const getLocationSuites = createSelector(
    getComponentState,
    (state) => state.variables.locationSuites
);
export const getLocationCities = createSelector(
    getComponentState,
    (state) => state.variables.locationCities
);
export const getLocationStates = createSelector(
    getComponentState,
    (state) => state.variables.locationStates
);
export const getLocationZips = createSelector(
    getComponentState,
    (state) => state.variables.locationZips
);
export const getColor = createSelector(
    getComponentState,
    (state) => state.variables.color
);
export const getStock = createSelector(
    getComponentState,
    (state) => state.variables.stock
);
export const getTitles = createSelector(
    getComponentState,
    (state) => state.variables.titles
);
export const getNotes = createSelector(
    getComponentState,
    (state) => state.variables.notes
);
export const getContact1Phone = createSelector(
    getComponentState,
    (state) => state.variables.contact1Phone
);
export const getContact1Type = createSelector(
    getComponentState,
    (state) => state.variables.contact1Type
);
export const getContact2Phone = createSelector(
    getComponentState,
    (state) => state.variables.contact2Phone
);
export const getContact2Type = createSelector(
    getComponentState,
    (state) => state.variables.contact2Type
);
export const getQuantity1 = createSelector(
    getComponentState,
    (state) => state.variables.quantity1
);
export const getQuantity2 = createSelector(
    getComponentState,
    (state) => state.variables.quantity2
);
export const getQuantity3 = createSelector(
    getComponentState,
    (state) => state.variables.quantity3
);
export const getLocations = createSelector(
    getComponentState,
    (state) => state.variables.locations
);
export const getPersonsNames = createSelector(
    getComponentState,
    (state) => state.variables.personsNames
);
export const getPersonsTitles = createSelector(
    getComponentState,
    (state) => state.variables.personsTitles
);
export const getAddingToCart = createSelector(
    getComponentState,
    (state) => state.addingToCart
);
export const getIsFavorite = createSelector(
    getComponentState,
    (state) => state.isFavorite
);
export const getAddingFavorite = createSelector(
    getComponentState,
    (state) => state.addingFavorite
);
export const getCheckingFavorite = createSelector(
    getComponentState,
    (state) => state.checkingFavorite
);
export const getSavingWork = createSelector(
    getComponentState,
    (state) => state.savingWork
);
export const getAction = createSelector(
    getComponentState,
    (state) => state.action
);
export const getAddToCartOrderType = createSelector(
    getComponentState,
    (state) => state.addToCartOrderType
);
export const getAddToCartType = createSelector(
    getComponentState,
    (state) => state.addToCartType
);
export const getPassword = createSelector(
    getComponentState,
    (state) => state.password
);
export const getShowChecks = createSelector(
    getComponentState,
    (state) => state.showChecks
);
export const getFetchingCheckControl = createSelector(
    getComponentState,
    (state) => state.fetchingCheckControl
);
export const getCheckControl = createSelector(
    getComponentState,
    (state) => state.checkControl
);
export const getFront = createSelector(
    getComponentState,
    (state) => state.variables.front
);
export const getBack = createSelector(
    getComponentState,
    (state) => state.variables.back
);
export const getSuiteRoom = createSelector(
    getComponentState,
    (state) => state.variables.suiteRoom
);
export const getFirstName = createSelector(
    getComponentState,
    (state) => state.variables.firstName
);
export const getMiddleName = createSelector(
    getComponentState,
    (state) => state.variables.middleName
);
export const getLastName = createSelector(
    getComponentState,
    (state) => state.variables.lastName
);
export const getPrimaryTitle = createSelector(
    getComponentState,
    (state) => state.variables.primaryTitle
);
export const getSecondaryTitle = createSelector(
    getComponentState,
    (state) => state.variables.secondaryTitle
);
export const getTitle4 = createSelector(
    getComponentState,
    (state) => state.variables.title4
);
export const getMain = createSelector(
    getComponentState,
    (state) => state.variables.main
);
export const getDirect = createSelector(
    getComponentState,
    (state) => state.variables.direct
);
export const getWebsite = createSelector(
    getComponentState,
    (state) => state.variables.website
);
export const getSchedulingCard = createSelector(
    getComponentState,
    (state) => state.variables.schedulingCard
);
export const getAddEnvelopes = createSelector(
    getComponentState,
    (state) => state.variables.addEnvelopes
);
export const getLetterheadPersons = createSelector(
    getComponentState,
    (state) => state.variables.letterheadPersons
);
export const getPrescriptionPadDoctors = createSelector(
    getComponentState,
    (state) => state.variables.prescriptionPadDoctors
);
export const getWindow = createSelector(
    getComponentState,
    (state) => state.variables.window
);
export const getShowSocialMediaIcons = createSelector(
    getComponentState,
    (state) => state.variables.showSocialMediaIcons
);
export const getAdditionalField = createSelector(
    getComponentState,
    (state) => state.variables.additionalField
);
export const getPhoneLabel1 = createSelector(
    getComponentState,
    (state) => state.variables.phoneLabel1
);
export const getPhoneLabel2 = createSelector(
    getComponentState,
    (state) => state.variables.phoneLabel2
);
export const getPhoneLabel3 = createSelector(
    getComponentState,
    (state) => state.variables.phoneLabel3
);
export const getPhoneOtherLabel1 = createSelector(
    getComponentState,
    (state) => state.variables.phoneOtherLabel1
);
export const getPhoneOtherLabel2 = createSelector(
    getComponentState,
    (state) => state.variables.phoneOtherLabel2
);
export const getPhoneOtherLabel3 = createSelector(
    getComponentState,
    (state) => state.variables.phoneOtherLabel3
);
export const getLanguage = createSelector(
    getComponentState,
    (state) => state.variables.language
);
export const getClinicId = createSelector(
    getComponentState,
    (state) => state.variables.clinic_id
);
export const getLocationId = createSelector(
    getComponentState,
    (state) => state.variables.location_id
);
export const getNursePhone = createSelector(
    getComponentState,
    (state) => state.variables.nursePhone
);
export const getFontType = createSelector(
    getComponentState,
    (state) => state.variables.fontType
);
export const getClinics = createSelector(
    getComponentState,
    (state) => state.clinics
);
export const getClinicLocations = createSelector(
    getComponentState,
    (state) => state.clinicLocations
);
export const getFetchingClinics = createSelector(
    getComponentState,
    (state) => state.fetchingClinics
);
export const getFetchingClinicLocations = createSelector(
    getComponentState,
    (state) => state.fetchingClinicLocations
);
export const getAvailableItems = createSelector(
    getComponentState,
    (state) => state.availableItems
);
export const getFetchingAvailableItems = createSelector(
    getComponentState,
    (state) => state.fetchingAvailableItems
);